import React from 'react';

import { FormattedMessage } from 'react-intl';
import { EnterpriseCardTitle } from '../../../../../enterprise/components/card/EnterpriseCardTitle';
import { EnterpriseDetails } from '../../../../../enterprise/components/card/EnterpriseDetails';
import { EntepriseFollowButton } from '../../../../../enterprise/components/EntepriseFollowButton';
import { Spacing } from '../../../../../components/entities-card/Spacing';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { EntitiesCardBody } from '../../../../../components/entities-card/EntitiesCardBody';
import { EntitiesCardFooter } from '../../../../../components/entities-card/EntitiesCardFooter';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { EnterpriseSnippetTabs } from './EnterpriseSnippetTabs';
import { Connect, PropsFromRedux } from './EnterpriseSnippetContainer';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { ResultsType } from '../../../../state/reducers/results.types';
import { UserContextType } from '../../../../../user/user.types';
import { withUser } from '../../../../../user/UserContext';
import { SnippetActions } from '../SnippetActions';

type Props = {
  enterprise: NonNullable<ResultsType['snippets']['enterprise']>;
} & UserContextType &
  WithRestrictedModalProps &
  PropsFromRedux;

export class RawEnterpriseSnippet extends React.Component<Props> {
  componentDidMount() {
    const { originalQueryKey, enterprise } = this.props;
    doctrineAnalytics('Search EnterpriseDisplayed', {
      enterprise_id: enterprise.enterpriseId,
      query_key: originalQueryKey,
    });
  }

  shouldComponentUpdate(nextProps: Props) {
    return (
      nextProps.enterprise.enterpriseId !==
        this.props.enterprise.enterpriseId ||
      nextProps.isFilterToggled !== this.props.isFilterToggled
    );
  }

  handleClick = (source: string) => () => {
    const { accessPremium, openRestrictedModal } = this.props;
    if (!accessPremium) {
      openRestrictedModal(source);
    }
  };

  render() {
    const {
      enterprise,
      originalQueryKey,
      accessPremium,
      isFilterToggled,
      toggleLawyerFilter,
    } = this.props;

    return (
      <div className="enterprise-snippet">
        <EntitiesCardBody>
          <EnterpriseCardTitle
            onClick={this.handleClick('search_enterprise_snippet-header')}
            href={
              accessPremium
                ? buildUrlWithParameters(enterprise.url, {
                    original_query_key: originalQueryKey,
                    source: 'search_enterprise_snippet-header',
                  })
                : undefined
            }
          >
            {enterprise.raisonSociale}
          </EnterpriseCardTitle>
          <EnterpriseDetails enterprise={enterprise} />
          <Spacing />
          <EntepriseFollowButton
            raisonSociale={enterprise.raisonSociale}
            enterpriseId={enterprise.enterpriseId}
          />
        </EntitiesCardBody>
        <SnippetActions
          isToggled={isFilterToggled}
          handleToggleOn={() => toggleLawyerFilter(enterprise.enterpriseId)}
          handleToggleOff={() => toggleLawyerFilter(undefined)}
        />
        <div className="enterprise-snippet__bottom">
          <EnterpriseSnippetTabs
            enterpriseId={enterprise.enterpriseId}
            siren={enterprise.siren}
            raisonSociale={enterprise.raisonSociale}
            url={enterprise.url}
            source="enterprise-snippet"
          />
        </div>
        <EntitiesCardFooter
          onClick={this.handleClick('search_enterprise_snippet-footer')}
          href={
            accessPremium
              ? `${enterprise.url}?source=search_enterprise_snippet-footer`
              : undefined
          }
        >
          <FormattedMessage id="search/components/search-snippets/aside/enterprise/EnterpriseSnippet.tsx/1" />
        </EntitiesCardFooter>
      </div>
    );
  }
}

export const EnterpriseSnippet = Connect(
  withRestrictedModal(withUser(RawEnterpriseSnippet)),
);
